import React from "react";

const AboutCard = ({ icon, title, disc }) => {
  return (
    <div className="relative w-full flex flex-col items-center shadow-2xl hover:border hover:border-[#00d4ff] hover:scale-110 group duration-300 hover:shadow-2xl rounded-xl">
      {/* <div className="absolute inset-0 bg-gradient-to-tr from-[#090979] to-[#00d4ff] rounded-xl"></div> */}
      <div className="relative h-full z-10 bg-white p-7 rounded-xl">
        <div className="flex space-x-3 items-center py-3">
          <div>
            <img
              src={icon}
              alt="icon"
              className="p-4 h-14 w-14 bg-blue-gray-400  group-hover:bg-[#00d5ff50] rounded-xl duration-300 group-hover:rounded-2xl bg-opacity-35"
            />
          </div>
          <div>
            <p className="text-xl mb-0 py-3 text-black font-bold">{title}</p>
          </div>
        </div>
        <div className="relative bottom-0">
          <p className="text-center text-gray-800 text-lg font-medium">
            {disc}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutCard;
